const topics = [
  { id: 1, tag: '#进击的巨人', posts: '12.8万', hot: 'high' },
  { id: 2, tag: '#鬼灭之刃', posts: '11.2万', hot: 'high' },
  { id: 3, tag: '#咒术回战', posts: '9.6万', hot: 'high' },
  { id: 4, tag: '#凡人修仙传', posts: '8.7万', hot: 'high' },
  { id: 5, tag: '#间谍过家家', posts: '7.5万', hot: 'medium' },
  { id: 6, tag: '#葬送的芙莉莲', posts: '6.8万', hot: 'medium' },
  { id: 7, tag: '#完美世界', posts: '6.3万', hot: 'medium' },
  { id: 8, tag: '#我推的孩子', posts: '5.9万', hot: 'medium' },
  { id: 9, tag: '#孤独摇滚', posts: '5.1万', hot: 'low' },
  { id: 10, tag: '#迷宫饭', posts: '4.6万', hot: 'low' },
  { id: 11, tag: '#国漫崛起', posts: '4.2万', hot: 'low' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            大家都在讨论的动漫话题，加入追番大家庭一起聊
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 bg-background-50 border-background-200/60 hover:border-accent-300/60 hover:bg-accent-50/50"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.posts}讨论</span>
              {topic.hot === 'high' && (
                <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                  热
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}